import client from "./axiosConfig";

// Get all Purchase Orders (local, synced from Zoho)
export const getPurchaseOrders = (params) => {
  const config = {
    url: "/procurement/purchase-orders/",
    method: "GET",
    params,
  };

  return client(config);
};

// Get Purchase Order by ID
export const getPurchaseOrderById = (id) => {
  const config = {
    url: `/procurement/purchase-orders/${id}/`,
    method: "GET",
  };

  return client(config);
};

// Get items for a Purchase Order (paginated)
export const getPurchaseOrderItems = (poId, params) => {
  const config = {
    url: `/procurement/purchase-orders/${poId}/items/`,
    method: "GET",
    params,
  };

  return client(config);
};

// Manually refresh a Purchase Order (and its items) from Zoho
export const refreshPurchaseOrder = (id) => {
  const config = {
    url: `/procurement/purchase-orders/${id}/refresh/`,
    method: "POST",
  };

  return client(config);
};

// Quick-edit a Purchase Order (currently just `site` - Accounts only)
export const updatePurchaseOrder = (id, data) => {
  const config = {
    url: `/procurement/purchase-orders/${id}/`,
    method: "PATCH",
    data,
  };

  return client(config);
};
